<template>


	<el-container class="lables" style="width: 80%;margin-left: 10%;">

		<el-row  class="la-list">
			<el-col :span="8" class="first">
        <el-row style="text-align: center;font-size: 28px;">
          <h2>W</h2>
        </el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in list1" :key="index">
					<div class="lable-o" style="float: left;" @click="up(item.l_id,'W')">
          {{item.name}}({{item.num}})
          </div>
          <div class="lable-o" style="float: left;">
          {{item.time}}
          </div>
				</el-row>
			</el-col>
      <el-col :span="8" class="first">
        <el-row style="text-align: center;font-size: 28px;">
          <h2>A</h2>
        </el-row>
      	<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in list2" :key="index">
      		<div class="lable-o" style="float: left;" @click="up(item.l_id,'A')">
      		{{item.name}}({{item.num}})
      		</div>
          <div class="lable-o" style="float: left;">
          {{item.time}}
          </div>
      	</el-row>
      </el-col>
      <el-col :span="8" class="first">
        <el-row style="text-align: center;font-size: 28px;">
          <h2>X</h2>
        </el-row>
      	<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in list3" :key="index">
      		<div class="lable-o" style="float: left;" @click="up(item.l_id,'X')">
      		{{item.name}}({{item.num}})
      		</div>
          <div class="lable-o" style="float: left;">
          {{item.time}}
          </div>
      	</el-row>
      </el-col>
		</el-row>

	</el-container>



</template>

<script>

  export default {
    data() {
      return {
        list1:[],
        list2:[],
        list3:[],
      };
    },
	created() {

	  this.loadData();

	},

	methods:{
    up(id,t){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/qwaxUpdateAll',
      	params:{
          id:id,
          t:t
        }
      })
      .then(res=>{
        this.$message({
        	type: 'success',
        	message: '更新成功'
        });
        this.loadData();

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/qwaxList'
			})
			.then(res=>{
				this.list1 = res.data.list1;
        this.list2 = res.data.list2;
        this.list3 = res.data.list3;

			})
			.catch(err=>{

			});
		},


	}


  }
</script>

<style>

	.content{

		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{

		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;

	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/qwax.vue